export default "__VITE_ASSET__CEUmx1UW__"